<template>
    <div class="medical-travelers">
        <p>{{ trans(label) }}</p>
        <ul class="travelers-list">
            <li v-for="traveler in travelers" :key="traveler.details.id">
                <new-checkbox id="checkbox" v-model="traveler.values[question]">
                    {{ traveler.details.name }}
                </new-checkbox>
            </li>
        </ul>
    </div>
</template>

<script>
import NewCheckbox from "../../Forms/NewCheckbox.vue";
export default {
    props: {
        trans: {
            type: [Function]
        },
        travelers: {
            type: [Array]
        },
        question: {
            type: String
        },
        label: {
            type: String,
            default: "medical_travelers.which_passengers"
        }
    },
    components: { NewCheckbox },
    methods: {
        selectTraveler(travelers, i) {
            travelers[i].values[this.question] = !travelers[i].values[
                this.question
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
.medical-travelers {
    margin-top: 20px;

    .travelers-list {
        margin-top: 10px;
        list-style: none;
        display: flex;
        flex-direction: column;
        gap: 15px;

        li {
            display: flex;
            gap: 10px;
            cursor: pointer;
        }
    }
}
</style>
